// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { Notification } from "../models/Notification";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type UserNotificationsData = Notification;

/** Params the client supplies at subscribe time. */
export type UserNotificationsParams = Record<string, never>;

export class UserNotificationsChannel extends Channel<UserNotificationsParams, UserNotificationsData> {
  static identifier = "UserNotificationsChannel";
}
